<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px">
      <breadcrumb></breadcrumb>
    </el-header>

    <el-main  v-loading.fullscreen.lock="loading">
      <el-form :model="form" ref="form" label-width="180px" label-position="left" >
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane :label="$t('field.feedbackContent')" name="first">
            <CreateFeedback ref="viewFeedback" :pFeedbackId.sync="form.feedbackId" @sync-custNo="syncCustNo" @sync-cust-feedback-file-save="syncCustFeedbackFileSave" :pOnlyView.sync="onlyView"/>
          </el-tab-pane>
          <el-tab-pane :label="$t('field.feedbackProcess')" name="second">
            <el-row :gutter="10">
              <el-col :span="8">    
                <el-form-item :label="$t('field.mainFae')"  >  
                  <el-select v-model="form.fae" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView">
                    <el-option v-for="item in faeOpts"  :key="item.value"  :label="item.label" :value="item.value"  ></el-option>
                  </el-select>
                  <!-- <EmployeeSearch @sync-select-employee="syncSelectEmployee" :pSelectEmp.sync="form.fae" :pOnlyView="onlyView" /> -->
                </el-form-item>                
              </el-col> 
              <el-col :span="8">    
                <el-form-item :label="$t('field.panelReceivedDate')"  label-width="150px">  
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="form.panelReceivedDate" :disabled="onlyView" style="width: 80%;"></el-date-picker>
                </el-form-item>                
              </el-col>
              <el-col :span="8"> 
                <el-form-item :label="$t('field.vrifiedDate')" label-width="150px" >  
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="form.vrifiedDate" :disabled="onlyView" style="width: 80%;"></el-date-picker>
                </el-form-item>                
              </el-col> 
            </el-row>
            <el-row :gutter="10">
              <el-col :span="13">
                <el-form-item label="Failure stage">  
                  <el-select v-model="form.failureStage" :placeholder="$t('msg.pleaseSelect')" style="width:100%" :disabled="onlyView">
                    <el-option v-for="item in failureStageOpts"  :key="item"  :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item :label="$t('field.judgmentofLiability')" label-width="250px">  
                  <el-select v-model="form.resp" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView">
                    <el-option v-for="item in resOpts"  :key="item"  :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>   
            <FeedbackFailureStage ref="feedbackFailureStage" :pFeedbackId="form.feedbackId" :onlyTable="onlyView" />
            <br>
            <!--
            <div class="workArea" >
              <h3>Software</h3>
              <div class="workContent">
                <el-checkbox-group v-model="form.softwareArr" :disabled="onlyView">
                  <el-checkbox label="Bug" name="software"></el-checkbox>
                  <el-checkbox label="Requirement" name="software"></el-checkbox>
                  <el-checkbox :label="otherStr" name="software"></el-checkbox>
                </el-checkbox-group>
                <el-input v-model="form.softwareComment" :placeholder="$t('msg.otherComment')" :disabled="onlyView"  maxlength=1000 ></el-input>
              </div>       
            </div>
            <br>
            -->
            <el-row>
              <el-col :span="12">
               <FeedbackUdi ref="feedbackUdi" :pFeedbackId="form.feedbackId" :onlyTable="onlyView" />
              </el-col>
            </el-row>
            <br>
         
            <div class="workArea">
              <h3>Issue Information</h3>   
               <el-row>
              <el-col :span="12">           
                <el-select v-model="form.issueInfo" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView" style="width:100%">
                  <el-option v-for="item in issueInfoOpts"  :key="item"  :label="item" :value="item"></el-option>
                </el-select>
          </el-col>
            </el-row>
                <br><br>
                <img src="../../assets/issueInformation.png" style=" max-height: 100%; max-width: 98%; "/>
                <br>
                <div class="workContent">
                  <el-form-item label-position:left label="reportable event"  >  
                  <el-select v-model="form.report" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView" >
                    <el-option v-for="item in reportOpts"  :key="item"  :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  label-position:left label="Is there a probability that the process design of FPD has caused or contributed to a death, serious illness, or serious injury?"  label-width="950px">  
                  <el-select v-model="form.isSerious" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView"  >
                    <el-option v-for="item in isSeriousOpts"  :key="item"  :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  label-position:left label="Is there a high probability that the process design of FPD has caused or contributed to the error of diagnosis?(ex. Image disorder)"  label-width="950px">  
                  <el-select v-model="form.isProcessWrong" :placeholder="$t('msg.pleaseSelect')" :disabled="onlyView" >
                    <el-option v-for="item in isProcessWrongOpts"  :key="item"  :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <h4 style="color:#ab2424">If yes, the quality department will be notified.</h4> 
              </div>  
            </div>
                     
             <br>
           
            <div class="workArea">
              <h3>Hardware repair part</h3>
              <div class="workContent">
                <el-form-item label="Electronic parts">
                  <el-checkbox-group v-model="form.electronicPartsArr" :disabled="onlyView" >
                    <el-checkbox label="C board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="X board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="Y board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="P board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="LED board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="RMV board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="GLG board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="ROIC" name="electronicParts"></el-checkbox>
                    <el-checkbox label="Gate IC" name="electronicParts"></el-checkbox>
                    <el-checkbox label="F board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="ARM board" name="electronicParts"></el-checkbox>
                    <el-checkbox label="WiFi module" name="electronicParts"></el-checkbox>
                    <el-checkbox :label="otherStr" name="electronicParts"></el-checkbox>
                  </el-checkbox-group>
                  <el-input v-model="form.electronicPartsComment" :placeholder="$t('msg.otherComment')" :disabled="onlyView"></el-input>
                </el-form-item>            
                <el-form-item label="Mechanism">
                  <el-checkbox-group v-model="form.mechanismArr" :disabled="onlyView">
                    <el-checkbox label="TSR" name="mechanism"></el-checkbox>
                    <el-checkbox label="PC film" name="mechanism"></el-checkbox>
                    <el-checkbox label="Caborn" name="mechanism"></el-checkbox>
                    <el-checkbox label="Back cover" name="mechanism"></el-checkbox>
                    <el-checkbox label="Middle board" name="mechanism"></el-checkbox>
                    <el-checkbox label="Antenna" name="mechanism"></el-checkbox>
                    <el-checkbox label="Cable" name="mechanism"></el-checkbox>
                    <el-checkbox label="Screw" name="mechanism"></el-checkbox>
                    <el-checkbox label="Connector" name="mechanism"></el-checkbox>
                    <el-checkbox label="Membrane button" name="mechanism"></el-checkbox>
                    <el-checkbox label="Battery pin" name="mechanism"></el-checkbox>
                    <el-checkbox label="FFC" name="mechanism"></el-checkbox>
                    <el-checkbox label="FPC" name="mechanism"></el-checkbox>
                    <el-checkbox label="Top cover" name="mechanism"></el-checkbox>
                    <el-checkbox :label="otherStr" name="mechanism"></el-checkbox>
                  </el-checkbox-group>
                  <el-input v-model="form.mechanismComment" :placeholder="$t('msg.otherComment')" :disabled="onlyView" ></el-input>
                </el-form-item>
                <el-form-item :label="otherStr">
                  <el-checkbox-group v-model="form.otherArr" :disabled="onlyView">
                    <el-checkbox label="Accessory" name="other"></el-checkbox>
                    <el-input v-model="form.accessoryComment" :placeholder="$t('msg.accessoryComment')"  :disabled="onlyView" ></el-input>
                    <el-checkbox label="The reason cannot be reproduced after returning to the factory" name="other"></el-checkbox>
                    <el-checkbox :label="otherStr" name="other"></el-checkbox>
                    <el-input v-model="form.otherComment" :placeholder="$t('msg.otherComment')" :disabled="onlyView" ></el-input>
                  </el-checkbox-group>              
                </el-form-item>
              </div>      
            </div>
            <br>
             <div class="workArea">
              <h3>Software Update</h3>
              <div class="workContent">
                <el-form-item label="Purpose">
                  <el-checkbox-group v-model="form.purposeArr" :disabled="onlyView">
                    <el-checkbox label="Bug" name="mechanism"></el-checkbox>
                    <el-checkbox label="Application" name="mechanism"></el-checkbox>
                    <el-checkbox label="Requirement" name="mechanism"></el-checkbox>
                   <!-- <el-checkbox label="Middle board" name="mechanism"></el-checkbox> -->
                    <el-checkbox label="System Issue (Not INCX Issue)" name="mechanism"></el-checkbox>                
                  </el-checkbox-group>
                </el-form-item>
               
              </div>
            </div>
            <br>
            <div class="workArea">      
              <h3>RMA Information</h3>
              <FeedbackRMA ref="feedbackRMA" :pFeedbackId="form.feedbackId" :pCustNo.sync="custNo" :onlyTable="onlyView" :pResp.sync="form.resp" /><br> 
            </div>
           
            <FeedbackCollaboration ref="feedbackCollaboration" :pFeedbackId="form.feedbackId" :onlyTable="onlyView" />
            <br>
        
            <h3>Description & Solution</h3>
            <el-input type="textarea" v-model="form.faeDescription"  maxlength=4000 :disabled="onlyView" show-word-limit rows="5"/>
            <br>
            <h3>Internal file record upload</h3>*For complaining cases, upload "Customer Complaint Evaluation Check List"(32RD000008-F002)
            <FileEditList ref="softwareFiles" :onlyView="onlyView" :docId="form.feedbackId" uploadType="feedback" subFolder="software" @sync-save-status="syncSoftwawreFileSave"/> <br>
            <br>
            <div style="width:100%;text-align:center;font-weight: bolder;"><span >The following is the content of communication with customers. 以下是與客戶溝通內容</span></div>
            <hr>
         
            <el-row ><el-col :span="24" >
                <FeedbackComm ref="feedbackComm" :lockAnalysisReport="onlyView" :pFeedbackId="form.feedbackId" @sync-cust-comm-file-save="syncCustAnalysisFileSave" />
            </el-col></el-row>
          
            <el-row style="padding-top: 10px;text-align:center" v-if="!onlyView" key="">  
              <el-col :span="24">      
                <el-button type="danger" @click="docDelete()">{{$t('button.docDelete')}}</el-button>    
                <el-button type="warning" @click="save()">{{$t('button.save')}}</el-button>      
                <el-button type="success" @click="close()">{{$t('button.closed')}}</el-button>
                
              </el-col>  
            </el-row>
            <br>
           
          </el-tab-pane>
        </el-tabs>  
      </el-form>
      <h3 v-if="showHistory">{{$t('field.signHistory')}}</h3>
      <div style="width:100%" v-if="showHistory">
        <el-row style="padding-top: 10px;text-align:right" >  
          <el-col :span="24">   
            <el-button type="success" @click="forwardFeedback()"  size="small" v-if="canApprove">{{$t('button.forward')}}</el-button>
            <el-button type="success" @click="approveFeedback()"  size="small" v-if="canApprove">{{$t('button.approve')}}</el-button>
            <el-button type="danger" @click="rejectFeedback()"  size="small" v-if="canReject">{{$t('button.reject')}}</el-button>
          </el-col>  
        </el-row>
        <el-table ref="historyTable" :data="historyTable.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" >
          <el-table-column v-for="(v, i) in historyTable.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
            <template slot-scope="scope">          
              <span>{{ scope.row[v.field] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog ref="signDialog" :title="$t('field.signDialogTitle')" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
        <el-form :model="signForm"  label-width="100px">
          <el-row>
            <el-col :span="10">
              <el-form-item :label="$t('field.signAction')" >
                <el-input v-model="signForm.signAction" :disabled="true" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>      
          <el-row v-if="signForm.signAction=='Forward'">
            <el-col :span="24">
              <el-form-item :label="$t('field.forwardPerson')"><!-- forwardEmp -->
                <EmployeeSearch @sync-select-employee="syncForwardEmp"  />   
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('field.signComment')" >
                <el-input v-model="signForm.signComment" type="textarea" maxlength="1000" show-word-limit rows="3"></el-input>
              </el-form-item>
            </el-col>        
          </el-row>         
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
          <el-button type="warning" @click="sendApprove">{{$t('button.submit')}}</el-button>
        </span>
      </el-dialog>

    </el-main>
    

  </div>
</template>

<script>

import Breadcrumb from '../components/Breadcrumb'
import { apiFindFeedbackFaeProcessByFeedbackId, apiSaveFeedbackFaeProcess, apiFeedbackStatusClosed, apiGetFeedbackAuth, apiFindCustIncxWindowsForFaeByFeedbackId,
         apiDeleteFeedbackDoc, apiFindProcessLogListByDocId, apiSendApproveFeedback } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
// import ViewFeedback from '../components/customerManage/ViewFeedback'
import CreateFeedback from '../customer/CreateFeedback'
import FeedbackFailureStage from "../components/customerManage/FeedbackFailureStage";
import FeedbackCollaboration from "../components/customerManage/FeedbackCollaboration";
import FeedbackRMA from "../components/customerManage/FeedbackRMA";
import FeedbackComm from "../components/customerManage/FeedbackComm";
import FeedbackUdi from "../components/customerManage/FeedbackUdi";
import FileEditList from "../components/FileEditList";
import CommonUtil from "../../utils/commonUtil.js";
import EmployeeSearch from '../components/EmployeeSearch'


export default {
  name: 'processFeedback',
  data() {    
    return {
      loading:false,    
      activeName: 'first',  
      otherStr:'Other',
      custNo:'',
      // pSelectEmp:'',
      onlyView: false,    
      canApprove:false,
      canReject:false,
      dialogVisible:false,
      showHistory:false,
      form:{                
        failureStage:'',
        feedbackId : '',
        resp : '', 
        report : '',
        isSerious : '',
        isProcessWrong : '',
        faeDescription : '',       
        softwareSolution : '',
        software : '',  //後端傳來字串但要轉換為陣列
        softwareArr : [], 
        softwareComment:'',
        electronicParts:'',
        electronicPartsArr : [],
        electronicPartsComment : '',
        mechanism:'',
        mechanismArr : [],
        mechanismComment : '',
        other:'',
        otherArr : [],
        accessoryComment : '',
        otherComment : '',
        purposeArr : [],
        issueInfoArr : [],
        issueInfo:'',
        purpose : '',
        issueInfo : '',
        fae:'',
        panelReceivedDate:'',
        vrifiedDate:'',
        
      },   
      signForm:{
        signAction:'', 
        signComment:'',
        forwardEmp:''
      }, 
      faeOpts:[],  
      issueInfoOpts:[ 'Complaint','CAPA (Notify the quality department)','Customer requests CAPA (Notify the quality department)','Technical support'],
      failureStageOpts:['DOA(An exception occurred during installation)','FA(An abnormality occurred after using for a while)',
        'LR(Semi-finished products are abnormal)','RR','RM','Unknown'],
      resOpts:['Customer','INCX'],
      reportOpts:['Yes','No'],
      isSeriousOpts:['Yes','No'],
      isProcessWrongOpts:['Yes','No'],
      isCustomer:false,
      saveSuccess:false,
      saveFileSuccess:false,
      saveSoftFileSuccess:false,
      saveAnalayFileSuccess:false,
      saveFileStatus:false,
      saveSoftFileStatus:false,
      saveAnalayFileStatus:false,
      historyTable:{
        columns: [ 
          { field: "taskName", title: this.$i18n.t('field.taskName'), width: 150 },         
          { field: "assignee", title: this.$i18n.t('field.taskOwner') , width: 180  },
          { field: "startTime", title:this.$i18n.t('field.taskReceived'), width: 150 },
          { field: "endTime", title: this.$i18n.t('field.taskSigned'), width: 150  },
          { field: "status", title: this.$i18n.t('field.signAction'), width: 150 },
          { field: "approveComment", title: this.$i18n.t('field.signComment') }
        ],
        data: []
      },
      failureStageItems:[]//for sync rma使用
    };
  },   
  components: {
    Breadcrumb,
    CreateFeedback,
    FeedbackFailureStage,
    FeedbackCollaboration,
    FeedbackRMA,
    FeedbackComm,
    FileEditList,
    FeedbackUdi,
    EmployeeSearch
  },
  mounted() {     
    apiFindCustIncxWindowsForFaeByFeedbackId({ headers: authHeader(), condition:this.form.feedbackId}).then((response) => { 
      this.faeOpts = [];
      response.data.forEach((item, index) => {   
        this.faeOpts.push({ value: item.value, label: item.value  });
      });
    }).catch((err) => {
      console.log(err);
    });
  },
  created(){   
    this.form.feedbackId = this.$route.params.id;  
    if(this.form.id == null){
      console.log("create");
    }else {     
      console.log("modify:"+this.form.id );
    }
    apiFindFeedbackFaeProcessByFeedbackId({ headers: authHeader(), feedbackId: this.form.feedbackId}).then((response) => { 
      if(response.status== 200 && response.data != null && response.data != ''){    
        this.setFormData(response.data);   
        if(this.custNo != null && this.custNo != ''){
          this.setAuth();  
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  },  
  watch:{
    custNo: function(){
      if(this.custNo != null && this.custNo != ''){
        this.setAuth();  
      }
    }
  },
  methods: {
    setAuth(){      
      apiGetFeedbackAuth({ headers: authHeader(), condition: this.custNo}).then((response) => { 
          if(response.data){
            this.onlyView = (this.$refs.viewFeedback.form.status != 'Closed' && this.$refs.viewFeedback.form.status != 'Cancelled' && 
                             this.$refs.viewFeedback.form.status != 'Under Review' ? false : true );           
          }else{
             this.onlyView = true;
          }

          apiFindProcessLogListByDocId({ headers: authHeader(), condition:this.form.feedbackId, condition1:'CS'}).then((response) => { 
            let auth = response.data.auth;
            if(response.data.historyList.length > 0){
              this.historyTable.data = response.data.historyList;
              this.showHistory = true;
            }else{
              this.showHistory = false;
            }      
            if(auth==true){
              this.canApprove = true;
              this.canReject = true;
            }else{
              this.canApprove = false;
              this.canReject = false;
            } 
            
            
          }).catch((err) => {
            console.log(err);
          });
        }).catch((err) => {
          console.log(err);
      });
    },
    setFormData(data){
      this.form.failureStage = data.failureStage;
      this.form.feedbackId= data.feedbackId;
      this.form.resp= data.resp; 
      this.form.report= data.report;
      this.form.isSerious= data.isSerious;
      this.form.isProcessWrong= data.isProcessWrong;
      this.form.faeDescription= data.faeDescription;       
      this.form.softwareSolution= data.softwareSolution;
      this.form.softwareComment= data.softwareComment;   
      this.form.electronicPartsComment= data.electronicPartsComment;  
      this.form.mechanismComment= data.mechanismComment;
      this.form.accessoryComment= data.accessoryComment;
      this.form.otherComment= data.otherComment;   
      this.form.purpose= data.purpose;
      this.form.issueInfo= data.issueInfo;
      this.form.softwareArr = CommonUtil.strToArr(data.software);
      this.form.electronicPartsArr = CommonUtil.strToArr(data.electronicParts);
      this.form.mechanismArr = CommonUtil.strToArr(data.mechanism);
      this.form.otherArr = CommonUtil.strToArr(data.other);
      this.form.purposeArr = CommonUtil.strToArr(data.purpose);
      this.form.issueInfo = data.issueInfo;       
      this.form.fae= data.fae;   
      this.form.panelReceivedDate = data.panelReceivedDate;
      this.form.vrifiedDate= data.vrifiedDate;
  
    },    
    checkForm(action){ 
      if(action=='close' && (this.form.issueInfo == 'Complaint' && (this.$refs.softwareFiles.tableData.data==null || this.$refs.softwareFiles.tableData.data.length ==0))){
        this.$message({ type: "warning", message: this.$i18n.t('msg.complaintIssueNeedAttach'), duration: 2000});
        return false;
      }else{
        return true;
      }
    },
    close() {
      if(!this.checkForm('close')){        
        return;
      }
      this.$confirm(this.$i18n.t('msg.confirmtoCloseFeedbackDoc'),{
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        }).then(_ => {  
          this.loading = true;         
          apiFeedbackStatusClosed({ headers: authHeader(), feedbackId: this.form.feedbackId}).then((response) => { 
            if(response.status== 200 ){    
              this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
              setTimeout(( () => location.reload()), 1000);
              this.loading = false;
            }
          }).catch((err) => {
            console.log(err);
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
            this.loading = false;
          });          
          done();
        }).catch(_ => {});
    },

    save() {
      if(!this.checkForm('save')){
        return;
      }
      if((this.form.electronicPartsArr.includes(this.otherStr) && (this.form.electronicPartsComment == null || this.form.electronicPartsComment == '')) ||
         (this.form.mechanismArr.includes(this.otherStr) && (this.form.mechanismComment == null || this.form.mechanismComment == '')) ||
         (this.form.otherArr.includes(this.otherStr) && (this.form.otherComment == null || this.form.otherComment == ''))){
        this.$message({ type: "warning", message: this.$i18n.t('msg.otherComment'), duration: 1000});
        return;
      }
      
      if(this.form.otherArr.includes('Accessory') && (this.form.accessoryComment == null || this.form.accessoryComment == '')){
        this.$message({ type: "warning", message: this.$i18n.t('msg.accessoryComment'), duration: 1000});
        return;
      }
 
      //將複選checkbox從陣列轉為字串, for 傳至後端處理
      //this.form.software = CommonUtil.arrToStr(this.form.softwareArr);
      this.form.electronicParts = CommonUtil.arrToStr(this.form.electronicPartsArr);
      this.form.mechanism = CommonUtil.arrToStr(this.form.mechanismArr);
      this.form.other = CommonUtil.arrToStr(this.form.otherArr);
      this.form.purpose = CommonUtil.arrToStr(this.form.purposeArr);
      //this.form.issueInfo = CommonUtil.arrToStr(this.form.issueInfoArr);      
      this.sendSaveApi();

    },
    sendSaveApi(){
      var feedback = this.$refs.viewFeedback.form;
      feedback.check1 = (feedback.check1==true ? 1 : 0);
      feedback.check2 = (feedback.check2==true ? 1 : 0);
      feedback.check3 = (feedback.check3==true ? 1 : 0);
      feedback.check4 = (feedback.check4==true ? 1 : 0);
      feedback.check5 = (feedback.check5==true ? 1 : 0);
      feedback.check6 = (feedback.check6==true ? 1 : 0);
      this.loading = true;
     
      apiSaveFeedbackFaeProcess({ 
        headers: authHeader(), 
        faeProcess: this.form,
        failureTypes:this.$refs.feedbackFailureStage.tableData.data,
        collaborates:this.$refs.feedbackCollaboration.tableData.data,   
        udis:this.$refs.feedbackUdi.tableData.data,
        rmas:this.$refs.feedbackRMA.tableData.data,  
        feedback: feedback,
        productTypes:this.$refs.viewFeedback.productTypeData
      }).then((response) => {    
          if(response.data){
            //this.$router.push("/ProcessFeedback/" +  response.data.faeProcess.feedbackId);
            //將複選checkbox從字串轉為陣列, for 畫面顯示     
            this.saveSuccess = true;
            this.setFormData(response.data.faeProcess);
            if(response.data.failureTypes) this.$refs.feedbackFailureStage.tableData.data =  response.data.failureTypes;
              this.$refs.feedbackCollaboration.tableData.data =  response.data.collaborates;
              this.$refs.feedbackUdi.tableData.data = response.data.udis;
              this.$refs.feedbackRMA.tableData.data= response.data.rmas;
              // SAVE FILE
              this.$refs.viewFeedback.$refs.fileList.save();
              this.$refs.feedbackComm.saveAnalysisReport();
              this.$refs.softwareFiles.save();           
            }else{
              this.loading = false;
              this.saveSuccess = false;              
            }
      }).catch((err) => {
        this.loading = false;
        this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
      });
    },
    tabClick(){

    },
    syncCustNo(custNo){
      this.custNo = custNo;      
    },
    //  syncSelectEmployee(empNo){
    //   this.form.fae = empNo;
    // },
    syncCustFeedbackFileSave(status){

      this.saveFileSuccess = true;
      this.saveFileStatus = status;
      if(this.saveFileSuccess && this.saveSoftFileSuccess && this.saveAnalayFileSuccess){
        //檔案皆已處理完畢
        if(this.saveSuccess && this.saveFileStatus && this.saveSoftFileStatus && this.saveAnalayFileStatus){
          this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          this.loading = false;
          setTimeout(( () => location.reload()), 1000);
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        }
      }
    },
    syncSoftwawreFileSave(status){
      this.saveSoftFileSuccess = true;
      this.saveSoftFileStatus = status;
      if(this.saveFileSuccess && this.saveSoftFileSuccess && this.saveAnalayFileSuccess){
        //檔案皆已處理完畢
        if(this.saveSuccess && this.saveFileStatus && this.saveSoftFileStatus && this.saveAnalayFileStatus){
          this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          this.loading = false;
          setTimeout(( () => location.reload()), 1000);
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        }
      }
    },
    syncCustAnalysisFileSave(status){
      this.saveAnalayFileSuccess = true;
      this.saveAnalayFileStatus = status;
      if(this.saveFileSuccess && this.saveSoftFileSuccess && this.saveAnalayFileSuccess){
        //檔案皆已處理完畢
        if(this.saveSuccess && this.saveFileStatus && this.saveSoftFileStatus && this.saveAnalayFileStatus){
          this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          this.loading = false;
          setTimeout(( () => location.reload()), 1000);
        }else{
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        }
      }
    },
    docDelete(){
       
      this.$confirm(this.$i18n.t('msg.confirmDeleteFeedback'), {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.loading = true;           
        apiDeleteFeedbackDoc({ headers: authHeader(), id: this.form.feedbackId}).then((response) => {            
          if(response.status== 200 && response.data ){   
            this.loading = false;
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});
            setTimeout(( () => location.reload()), 1000);
          }else{
            this.loading = false;
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
          }          
        }).catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
        });
        
        done();
      }).catch(_ => {});
    },
    approveFeedback(){
      this.signForm.signAction = 'Approve';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    forwardFeedback(){
      this.signForm.signAction = 'Forward';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    rejectFeedback(){
      this.signForm.signAction = 'Reject';
      this.signForm.signComment = '';
      this.dialogVisible = true;
      this.signForm.forwardEmp ='';
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.dialogVisible = false;
        done();
      }).catch(_ => {});
    },
    sendApprove(){
      this.signForm.signAction;
      this.signForm.signComment;

      if( this.signForm.signAction=='Reject' && CommonUtil.isNull(this.signForm.signComment) ){
        return this.$message({ type: "error", message: this.$i18n.t('msg.commentRequiredWhenSignActionRejected'), duration: 1000}); 
      } else {                 
        apiSendApproveFeedback({ headers: authHeader(), id: this.form.feedbackId,signAction: this.signForm.signAction, signComment: this.signForm.signComment, forwardEmp:this.signForm.forwardEmp}).then((response) => {   
          this.dialogVisible = false;                  
          if(response.status== 200 && response.data != null && response.data != ''){
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 900}); 
            this.dialogVisible = false;   
            setTimeout(( () => location.reload()), 1000);
          }else{
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});  
            this.loading = false;      
          }
        }).catch((err) => {  
          console.log(err);  
          this.dialogVisible = false;
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 1000});  
        });
      }
    },
    syncForwardEmp(empNo){
      this.signForm.forwardEmp = empNo;
    },
  }
};
</script>

<style>

.workArea{
  width: 100%; 
  background:#ff00000d;
  padding:10px
}
.workContent{
  width: 98%; 
}

</style>